module.exports = __webpack_public_path__ + "static/media/rock7-01.23524b07.svg";